// Consumer Profile reducer

import * as types from '../actions/actionTypes';

const INITIAL_STATE = {
    data: null,
    editMode: false,
    changes: null,
    errors: null,
    errorGet: null,
    errorUpd: null,
};

export default function profileReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case types.PROFILE_DATA: {
            return {
                ...INITIAL_STATE,
                data: action.data,
            };
        }

        case types.PROFILE_EDIT_MODE: {
            const editMode =
                action.editMode != null ? action.editMode : !state.editMode;
            return { ...state, editMode, changes: null, errors: null };
        }

        case types.PROFILE_CHANGE: {
            const { item, value } = action;
            const { field, validator, required, requiredMsg } = item;

            const emptyValue = value === '';
            const falseValue = value === false;

            const oldValue = state.data?.[field];
            const sameValue =
                oldValue === value ||
                (oldValue == null && falseValue) ||
                (oldValue == null && emptyValue);

            const changes = state.changes || {};
            const newChanges = { ...changes, [field]: value };

            let error = null;
            if (!error && required && emptyValue)
                error = requiredMsg || 'Required.';
            if (!error) error = validator && validator(value);
            if (error && !required && emptyValue) error = null;

            const errors = state.errors || {};
            const newErrors = { ...errors, [field]: error };

            if (sameValue) delete newChanges[field];
            if (!error) delete newErrors[field];

            return {
                ...state,
                changes: newChanges,
                errors: newErrors,
            };
        }

        case types.PROFILE_CHANGE_CLEAR: {
            return { ...state, changes: null, errors: null };
        }

        case types.PROFILE_GET_ERROR: {
            return {
                ...INITIAL_STATE,
                errorGet: action.error,
                errorUpd: null,
            };
        }

        case types.PROFILE_UPD_ERROR: {
            return {
                ...state,
                errorGet: null,
                errorUpd: action.error,
            };
        }

        default:
            return state;
    }
}
